<app-header></app-header>

<div id="app">
  <app-sidebar *ngIf="sidebarVisible" class="sidebar sidebar-left" (sidebarOpened)="pushContent()" (sidebarClosed)="pullContent()"> </app-sidebar>

  <div #contentWrapper class="content-wrapper d-flex flex-column" [class.no-sidebar-padding]="!sidebarVisible">
    <router-outlet></router-outlet>
  </div>
</div>
